
import Modal from 'react-modal';
import { DropDown, Input, CheckBox } from '../controls';
import { DataContext } from '../../data/DataContext';
import { typeDocument, txtAcceptTerm } from '../../data/MochaData';
import { useContext, useState } from 'react';

const Step1 = () => {

    const { IH_CR, setIH_CR, changeHandler } = useContext(DataContext);
    const [openModalAccept, setOpenModalAccept] = useState(false);

    const txtAccepTerm: string = 'Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones.';

    const onChangeChk = (property: string, value: boolean) => {
        setIH_CR({ ...IH_CR, [property]: value });
    }

    const onChangeCbo = (property: string, value: string) => {
        setIH_CR({ ...IH_CR, [property]: value });
    }

    return (
        <>
            <DropDown
                label='Tipo de identificación*'
                dataProvider={typeDocument}
                valueSelect={IH_CR.identificationType}
                field='identificationType'
                onChangeSelect={onChangeCbo}
            />
            {IH_CR.identificationType == '1' &&
                <Input
                    id='identification'
                    label='Número de identificación*'
                    value={IH_CR.identification}
                    field='identification'
                    onChange={changeHandler}
                    placeholder="Identificación"
                    type='mask'
                    mask="9-9999-9999"
                    pattern="\d-\d\d\d\d-\d\d\d\d"
                    title="Documento invalido"
                />
            }
            {IH_CR.identificationType != '1' &&
                <Input
                    id='identification'
                    label='Número de identificación*'
                    value={IH_CR.identification}
                    field='identification'
                    onChange={changeHandler}
                    placeholder="Identificación"
                />
            }
            <Input
                id='firstName1'
                label='Nombres*'
                value={IH_CR.firstName1}
                field='firstName1'
                onChange={changeHandler}
                placeholder="Primer Nombre"
            />
            <Input
                id='firstName2'
                label='Nombres*'
                value={IH_CR.firstName2}
                field='firstName2'
                onChange={changeHandler}
                onlyInput={true}
                placeholder="Segundo Nombre"
                isRequired={false}
            />
            <Input
                id='lastName1'
                label='Apellidos*'
                value={IH_CR.lastName1}
                field='lastName1'
                onChange={changeHandler}
                placeholder="Primer Apellido"
            />
            <Input
                id='lastName2'
                label='Nombres*'
                value={IH_CR.lastName2}
                field='lastName2'
                onChange={changeHandler}
                onlyInput={true}
                placeholder="Segundo Apellido"
                isRequired={false}
            />
            <Input
                id='phoneNumber'
                label='Número de Celular*'
                value={IH_CR.phoneNumber}
                field='phoneNumber'
                onChange={changeHandler}
                placeholder="8888-8888"
                type='mask'
                mask="9999-9999"
                title="Documento invalido"
            />
            <Input
                id='mail'
                label='Correo electrónico*'
                value={IH_CR.mail}
                field='mail'
                onChange={changeHandler}
                placeholder="ejemplo@ejemplo.com"
            />
            <CheckBox
                label={txtAccepTerm}
                value={IH_CR.acceptTerms}
                field='acceptTerms'
                onChange={onChangeChk}
                onClickLabel={() => { setOpenModalAccept(true) }}
            />
            <Modal className='modal modal-ihcr' isOpen={openModalAccept}>
                <div className='modal-body-ihcr'>
                    <span className='modal-label-body-ihcr'>
                        {txtAcceptTerm}
                    </span>
                </div>
                <div className="modal-footer-ihcr">
                    <button className="modal-btn-close-ihcr" onClick={() => setOpenModalAccept(false)}>Cerrar</button>
                </div>
            </Modal>
        </>
    );
}

export { Step1 };